// Audio mix and tuning knobs, shown in the dev panel under 'Audio'.

import { param } from '../config/params';

const level = (id: string, label: string, value: number, max = 2): ReturnType<typeof param> =>
  param({ id: `audio.${id}`, label, group: 'Audio', min: 0, max, step: 0.05, value });

export const audioParams = {
  master: level('master', 'Master volume', 0.9, 1.5),
  engine: level('engine', 'Engine level', 1),
  turbo: level('turbo', 'Turbo whistle level', 1),
  ers: level('ers', 'MGU-K whine level', 1),
  tyres: level('tyres', 'Tyre squeal level', 1),
  surface: level('surface', 'Kerb / off-track level', 1),
  wind: level('wind', 'Wind / road level', 1),
  impact: level('impact', 'Impact level', 1),
  pops: level('pops', 'Overrun pops level', 1),
  squealOnset: param({ id: 'audio.squealOnset', label: 'Squeal onset (grip use)', group: 'Audio', min: 0.7, max: 1, step: 0.01, value: 0.92 }),
  squealSlipDeg: param({ id: 'audio.squealSlipDeg', label: 'Slide squeal from (slip deg)', group: 'Audio', min: 2, max: 15, step: 0.5, value: 6 }),
  squealPitch: param({ id: 'audio.squealPitch', label: 'Squeal pitch (Hz)', group: 'Audio', min: 500, max: 2000, step: 10, value: 1050 }),
  ersHzPerMs: param({ id: 'audio.ersHzPerMs', label: 'MGU-K whine Hz per m/s', group: 'Audio', min: 4, max: 30, step: 0.5, value: 13 }),
  // Below 1 lowers the whole engine note (the true V6 firing frequency at 1).
  enginePitch: param({ id: 'audio.enginePitch', label: 'Engine pitch', group: 'Audio', min: 0.6, max: 1.2, step: 0.01, value: 0.85 }),
  engineBright: param({ id: 'audio.engineBright', label: 'Engine brightness', group: 'Audio', min: 0.4, max: 2, step: 0.05, value: 1 }),
};
